import { lazy } from 'react';

export const SessionRightPanelLazy: React.LazyExoticComponent<() => JSX.Element> = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_conversation-assistant" */ './SessionRightPanel'
	).then((module) => ({ default: module.SessionRightPanel })),
);
